// Gruppi di Acquisto Risparmio: id basato sullo SKU del prodotto.
// Stessa regola del backend (backend/risparmio_gruppi.py):
//   GA-<default_sku>              (SKU completo, mai troncato)
//   GA-P-<NOME-PRODOTTO-COMPLETO> (fallback se il prodotto non ha SKU)
// Il vecchio id (nome troncato a 20 caratteri) faceva collidere prodotti diversi.

const clean = (value) => String(value ?? "").trim();

export const productSku = (product = {}) =>
  clean(product.default_sku || product.tiers?.[0]?.sku).toUpperCase();

export const productGroupId = (product = {}) => {
  if (clean(product.group_id)) return clean(product.group_id);
  const sku = productSku(product);
  if (sku) return `GA-${sku}`;
  const name = clean(product.product_key || product.name);
  return `GA-P-${name.replace(/[^a-zA-Z0-9]/g, "-").toUpperCase()}`;
};

// Associa un'adesione al gruppo del proprio prodotto: prima per SKU (riferimento
// prodotto, gestisce anche adesioni legacy non ancora migrate), poi per id gruppo.
// `gruppi` sono prodotti del listino ({group_id|id, tiers}) o gruppi UI ({id, tiers}).
export const buildGroupResolver = (gruppi = []) => {
  const bySku = new Map();
  const ids = new Set();
  for (const g of gruppi) {
    const id = g.id || productGroupId(g);
    ids.add(id);
    for (const tier of g.tiers || []) {
      const sku = clean(tier?.sku).toUpperCase();
      if (sku && !bySku.has(sku)) bySku.set(sku, id);
    }
  }
  return (adesione = {}) => {
    const sku = clean(adesione.sku ?? adesione.sku_prodotto).toUpperCase();
    if (sku && bySku.has(sku)) return bySku.get(sku);
    const id = clean(adesione.id_gruppo_acquisto || adesione.id_gruppo);
    return ids.has(id) ? id : null;
  };
};

export const countAdesioniByGroup = (adesioni = [], gruppi = []) => {
  const resolve = buildGroupResolver(gruppi);
  const counts = {};
  for (const a of adesioni) {
    const id = resolve(a);
    if (id) counts[id] = (counts[id] || 0) + 1;
  }
  return counts;
};

export const joinedGroupIds = (adesioni = [], gruppi = [], strutturaId) => {
  const resolve = buildGroupResolver(gruppi);
  const out = new Set();
  for (const a of adesioni) {
    if (strutturaId != null && String(a.struttura_id ?? "") !== String(strutturaId)) continue;
    const id = resolve(a);
    if (id) out.add(id);
  }
  return out;
};
